module.exports = __webpack_public_path__ + "img/running.dfaed7e2.jpg";